export const Assets = {

    AvatarNotifTwo: require("./images/avatartwo.png"),

}